import { Modal } from 'antd'
import React, { useState } from 'react'
import { useEffect } from 'react';
import ReactPlayer from 'react-player'
import { Translate } from 'react-translated'

function ViewVideoModal(props) {
const [isPlaying, setisPlaying] = useState(false);

useEffect(() => {
  if(props.data.url && props.isViewVideoModal){
    setisPlaying(true)
  }
}, [props])


  return (
    <Modal
    title={
      <Translate text={props.data.title ? props.data.title : ''} />
    }
    centered
    visible={props.isViewVideoModal}
    footer={null}
    width={688}
    onCancel={() =>{ setisPlaying(false); props.onCancel()}}
    maskClosable={false}
    
  >
    <ReactPlayer url={props.data.url} className="videoContent" controls={true} playing={isPlaying}   />
  </Modal>
  )
}

export default ViewVideoModal


// WEBPACK FOOTER //
// ./src/scenes/Training/viewVideoModal.js